type ResumePositionInput = {
  playbackPositionTicks?: number;
  runTimeTicks?: number;
  played?: boolean;
  startOver?: boolean;
};

const TICKS_PER_SECOND = 10_000_000;

export function resolveResumePositionSeconds({
  playbackPositionTicks = 0,
  runTimeTicks = 0,
  played = false,
  startOver = false,
}: ResumePositionInput) {
  if (startOver || played) return 0;
  const position = Number.isFinite(playbackPositionTicks)
    ? Math.max(0, playbackPositionTicks / TICKS_PER_SECOND)
    : 0;
  const duration = Number.isFinite(runTimeTicks)
    ? Math.max(0, runTimeTicks / TICKS_PER_SECOND)
    : 0;
  if (duration <= 0 || position <= 0) return position;

  const clamped = Math.min(position, duration);
  const remaining = duration - clamped;
  if (clamped / duration >= 0.95 || remaining <= 30) return 0;
  return clamped;
}
